import { render, staticRenderFns } from "./reservationDetailContent.vue?vue&type=template&id=445babdf"
import script from "./reservationDetailContent.vue?vue&type=script&lang=js"
export * from "./reservationDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports